export default __webpack_public_path__ + "media/calendar-o.cacbe866.svg";